const kwAppEnvOrDefault = (propertyName: string, defaultValue: string): string => {
    const anyWindow: any = window;
    return anyWindow?.kwAppEnv?.[propertyName] ?? defaultValue;
};

export const environment = {
    production: true,
    profiles: kwAppEnvOrDefault("profiles", "n/a"),
    stageBannerVisible: kwAppEnvOrDefault("stageBannerVisible", "true") === "true",
    stageBannerTextColor: kwAppEnvOrDefault("stageBannerTextColor", "#ffffff"),
    stageBannerBackgroundColor: kwAppEnvOrDefault("stageBannerBackgroundColor", "#188310"),
    stageBannerTextDe: kwAppEnvOrDefault("stageBannerTextDe", "Testumgebung"),
    stageBannerTextFr: kwAppEnvOrDefault("stageBannerTextFr", "Environnement de test"),
    stageBannerTextIt: kwAppEnvOrDefault("stageBannerTextIt", "Ambiente di prova"),
    stageBannerDescriptionDe: kwAppEnvOrDefault("stageBannerDescriptionDe", "localhost"),
    stageBannerDescriptionFr: kwAppEnvOrDefault("stageBannerDescriptionFr", "localhost"),
    stageBannerDescriptionIt: kwAppEnvOrDefault("stageBannerDescriptionIt", "localhost"),
    branding: kwAppEnvOrDefault("branding", "valumize"),
};
